import React from 'react';
import {useProviderProfile} from "../../../../../ProviderProfileProvider";
import {KensuTable} from "../../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {useCatalogTabs} from "../CatalogRouter";

import {useNavigateWithParams} from "../../../../../util/NavUtils";
import {priceToString} from "../../../../../util/PriceUtil";
import {findPriceCategory} from "../../Calendar/CalendarUtil";

export const Services = () => {

  const {businessProfile} = useProviderProfile();
  const navigate = useNavigateWithParams();
  const catalogTabs = useCatalogTabs();

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Catalog'}
                      buttons={[{text: 'Add Service', link: 'add'}]}
                      tabs={catalogTabs}/>

    <div className={'ProviderToolAreaContent'}>

      Let’s help your clients discover your offerings. Here's where you curate your services and/or classes, packages, and pricing.
      <br/><br/>
      
          <KensuTable data={businessProfile?.practice?.services}
                      onRowSelected={(row) => navigate(`/home/catalog/services/edit/${row.sku}`)}
                      columns={[
                        {
                          label: 'Name',
                          render: (r) => r.name,
                          sortString: r => r.name,
                          showArchivedBadge: r => r.archived
                        },
                        {label: 'Category', render: r => r.category, sortString: r => r.category},
                        {label: 'Length', render: r => r.lengthMinutes + ' min', sortOrder: r => r.lengthMinutes},
                        {
                          label: 'Price', render: r => {
                            if (r.paymentPolicy?.prepaid?.priceCategoryId) {
                              return "Price category: " + findPriceCategory(businessProfile, r.paymentPolicy.prepaid.priceCategoryId)?.displayName
                            }

                            return priceToString(r.paymentPolicy?.prepaid?.price ?? r.paymentPolicy?.postpaid?.price, true)
                          },
                        }
                      ]}
          />
      

      {!businessProfile?.practice?.services?.length && <div>
        <br/>
          <b>No services listed yet. </b> Click <b>“Add”</b> to create your first service and begin shaping your
          practice.
      </div>}

    </div>
  </div>

};

